import { Button, Skeleton, Tag } from 'antd';
import moment from 'moment';
import styled, { createGlobalStyle } from 'styled-components';
import { latitudeFormat, longitudeFormat } from '../../../helpers/map-util';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { getTodayReportRange } from '../../../helpers/reportRange';
import { useEffect, useState } from 'react';
import { LoadingWrapper } from '../../report/dailyReport';
import { AssetProperties, initialAsset } from '../../asset/types/asset.type';
import useGroup from '../../../zustand/useGroup';
import { VesselStatus } from '../../../helpers/vessel';
import { toKnot } from '../../report/components/helperFunction';
import { httpRequest } from '../../../helpers/api';
import {
  BaseResponsePaginationProps,
  BaseResponseProps,
  generateQueryString,
} from '@qlibs/react-components';
import { DeviceProperties } from '../../device/types/device.type';
import { EReportDataInterval } from '../../report/types/report-log.type';

interface IProps {
  assetId?: string;
  timestamp: any;
  latitude: number;
  longitude: number;
  altitude: number;
  speed: string;
  rpmPort?: {
    timestamp: number;
    rpm: number;
    runningTime: string;
  };
  rpmStarboard?: {
    timestamp: number;
    rpm: number;
    runningTime: string;
  };
  rpmCenter?: {
    timestamp: number;
    rpm: number;
    runningTime: string;
  };
  ae1?: {
    fuelCons: number;
    runningTime: number;
  };
  ae2?: {
    fuelCons: number;
    runningTime: number;
  };
  ae3?: {
    fuelCons: number;
    runningTime: number;
  };
  vesselStatus?: VesselStatus;
  isEngineOn?: boolean;
  rpm?: any;
}

const MapVesselPopup: React.FC<IProps> = ({
  assetId,
  timestamp,
  latitude,
  longitude,
  altitude,
  speed,
  vesselStatus = VesselStatus.OFFLINE,
  isEngineOn = false,
  rpmPort,
  rpmStarboard,
  rpmCenter,
}) => {
  const { pathname } = useLocation();
  const [asset, setAsset] = useState<any>(initialAsset);
  const [loadingAsset, setLoadingAsset] = useState<boolean>(false);
  const navigate = useNavigate();

  const { filter, setFilter, setAsset: setAssetStorage, timezone } = useGroup();
  const [searchParams, setSearchParams] = useSearchParams();

  async function onClickAction(type: 'report' | 'dashboard') {
    try {
      const res = await httpRequest.get<
        BaseResponsePaginationProps<DeviceProperties>
      >(
        `/device${generateQueryString({
          filterAssetIds: asset.assetId,
          filterStatus: 'active',
        })}`
      );

      const resDevices = res.data.payload.results.map((item) =>
        item.deviceType.name.toLocaleLowerCase()
      );

      const { startAt, endAt } = getTodayReportRange(timezone);

      const newFilter: any = {
        ...filter,
        startAt,
        endAt,
        interval: EReportDataInterval.minute,
        deviceType: [...new Set(resDevices)].join(','),
        deviceId: undefined,
        assetId: assetId,
      };

      setAssetStorage(asset);
      setFilter(newFilter);

      setSearchParams({ ...(newFilter as any) });

      if (type === 'report') {
        navigate(`/report-log${generateQueryString(newFilter)}`);
      } else {
        navigate(`/dashboard${generateQueryString(newFilter)}`);
      }
    } catch (error) {
      console.error(`failed action ${type}`, error);
      console.error(error);
    }
  }

  // console.log('filter', filter);

  const [reRender, setReRender] = useState<number>(0);

  // async function handleToggleTrail() {
  //   try {
  //     if (asset.massDevice) {
  //       const currDevcMassId = asset.massDevice.find(
  //         (item: any) => item.devcType === "gps"
  //       )?.devcMassId;

  //       if (currDevcMassId) {
  //         await fetchCurrentAssetTrail({
  //           massId: asset.massId,
  //           devcMassId: currDevcMassId,
  //           devcType: "gps",
  //         });

  //         setTmpToggle((old) => !old);
  //         setReRender((old) => old + 1);
  //       } else {
  //         console.log("data devcMassId not found");
  //       }
  //     }
  //   } catch (error) {
  //     console.error("failed show asset trail", error);
  //   }
  // }

  useEffect(() => {}, [reRender]);

  const convertTimestampToDate = (timestamp?: number) => {
    if (timestamp) {
      return moment(timestamp * 1000).format('DD MMM YYYY HH:mm');
    }

    return '-';
  };

  useEffect(() => {
    async function fetchAssetDetail() {
      try {
        setLoadingAsset(true);
        const result = await httpRequest.get<
          BaseResponseProps<AssetProperties>
        >(`/asset/${assetId}`);
        if (result.data.payload) {
          setAsset(result.data.payload);
        }
      } catch (error) {
        console.error('Failed get one asset', error);
      } finally {
        setLoadingAsset(false);
      }
    }

    fetchAssetDetail();
    setReRender((old) => old + 1);
  }, []);

  // const items: TabsProps['items'] = [
  //   {
  //     key: '1',
  //     label: 'GPS',
  //     children: (
  //       <ContentWrapper>
  //         <GridContent>
  //           <ItemContent
  //             label='Latitude'
  //             value={latitudeFormat(latitude, longitude)}
  //           />
  //           <ItemContent
  //             label='Longitude'
  //             value={longitudeFormat(latitude, longitude)}
  //           />
  //         </GridContent>

  //         <GridContent>
  //           <ItemContent
  //             label='Altitude'
  //             value={altitude ? (altitude as number).toFixed(2) : '-'}
  //           />
  //           <ItemContent
  //             label='Speed'
  //             value={toKnot(Number(speed) ?? 0).toFixed(2) + '  Knot'}
  //           />
  //         </GridContent>
  //       </ContentWrapper>
  //     ),
  //   },
  //   {
  //     key: '2',
  //     label: 'RPM',
  //     children: (
  //       <ContentWrapper>
  //         <GridContent>
  //           <ItemContent
  //             label='RPM'
  //             value={rpmPort && rpmPort?.rpm ? rpmPort?.rpm.toFixed() : '-'}
  //           />
  //           <ItemContent
  //             label='Run. Time'
  //             value={
  //               rpmPort && rpmPort?.runningTime
  //                 ? toHHMM(rpmPort?.runningTime)
  //                 : '-'
  //             }
  //           />
  //         </GridContent>
  //       </ContentWrapper>
  //     ),
  //   },
  //   {
  //     key: '3',
  //     label: 'AE',
  //     children: (
  //       <ContentWrapper>
  //         <GridContent>
  //           <ItemContent
  //             label='AE 1 Run. Time'
  //             value={ae1?.runningTime ? toHHMM(ae1.runningTime) : '-'}
  //           />
  //           <ItemContent
  //             label='AE 1 Fuel Cons.'
  //             value={ae1?.fuelCons ? ae1?.fuelCons.toFixed() : '-'}
  //           />
  //         </GridContent>
  //         <GridContent>
  //           <ItemContent
  //             label='AE 2 Run. Time'
  //             value={ae2?.runningTime ? toHHMM(ae2.runningTime) : '-'}
  //           />
  //           <ItemContent
  //             label='AE 2 Fuel Cons.'
  //             value={ae2?.fuelCons ? ae2?.fuelCons.toFixed() : '-'}
  //           />
  //         </GridContent>
  //         <GridContent>
  //           <ItemContent
  //             label='AE 3 Run. Time'
  //             value={ae3?.runningTime ? toHHMM(ae3.runningTime) : '-'}
  //           />
  //           <ItemContent
  //             label='AE 3 Fuel Cons.'
  //             value={ae3?.fuelCons ? ae3?.fuelCons.toFixed() : '-'}
  //           />
  //         </GridContent>
  //       </ContentWrapper>
  //     ),
  //   },
  // ];

  return (
    <Container className='custom-popup'>
      <PopupGlobalStyle />
      {loadingAsset && !asset?.assetId ? (
        <LoadingWrapper style={{ alignItems: 'flex-start' }}>
          <Skeleton.Image active />
          <div>
            <Skeleton.Button active size='large' block />
            <Skeleton.Button active size='large' block />
            <Skeleton.Button active size='large' />
          </div>
        </LoadingWrapper>
      ) : (
        <>
          <PopupHeader>
            <HeaderTitleGroup>
              <Title>{asset?.name}</Title>
              <LastUpdated>
                Last updated GPS: {convertTimestampToDate(timestamp)}
              </LastUpdated>
            </HeaderTitleGroup>
            <StatusGroup>
              <StatusItem $width={120}>
                <div>Vessel</div>
                <Tag
                  style={{
                    fontWeight: 'bold',
                    color:
                      vesselStatus === VesselStatus.ONLINE
                        ? '#1e9b24'
                        : vesselStatus === VesselStatus.OFFLINE
                        ? '#b81414'
                        : '#c07d19',
                    backgroundColor:
                      vesselStatus === VesselStatus.ONLINE
                        ? '#95f39a'
                        : vesselStatus === VesselStatus.OFFLINE
                        ? '#ffb4b4'
                        : '#f1ddbf',
                    border: 'none',
                  }}
                  // color={
                  //   vesselStatus === VesselStatus.ONLINE
                  //     ? '#55C95A'
                  //     : vesselStatus === VesselStatus.OFFLINE
                  //     ? '#FE4545'
                  //     : '#A4660A'
                  // }
                >
                  {vesselStatus.toUpperCase()}
                </Tag>
              </StatusItem>
              <StatusItem $width={70}>
                <div>Engine</div>
                <Tag
                  style={{
                    fontWeight: 'bold',
                    color: isEngineOn ? '#1e9b24' : '#b81414',
                    backgroundColor: isEngineOn ? '#95f39a' : '#ffb4b4',
                    border: 'none',
                  }}
                  // color={`${isEngineOn ? '#55C95A' : '#FE4545'}`}
                >
                  {isEngineOn ? 'ON' : 'OFF'}
                </Tag>
              </StatusItem>
            </StatusGroup>
          </PopupHeader>

          <PopupBody>
            <ImageFrame>
              <img
                src={
                  asset?.imageLink
                    ? asset?.imageLink
                    : '/images/empty-image.png'
                }
              />
            </ImageFrame>

            <MobileSummaryGrid>
              <ItemContent
                label='Last Updated'
                value={convertTimestampToDate(timestamp)}
              />
              <Item>
                <div>Vessel Status</div>
                <Tag
                  style={{
                    fontWeight: 'bold',
                    color:
                      vesselStatus === VesselStatus.ONLINE
                        ? '#1e9b24'
                        : vesselStatus === VesselStatus.OFFLINE
                        ? '#b81414'
                        : '#c07d19',
                    backgroundColor:
                      vesselStatus === VesselStatus.ONLINE
                        ? '#95f39a'
                        : vesselStatus === VesselStatus.OFFLINE
                        ? '#ffb4b4'
                        : '#f1ddbf',
                    border: 'none',
                  }}
                >
                  {vesselStatus.toUpperCase()}
                </Tag>
              </Item>
              <Item>
                <div>Engine Status</div>
                <Tag
                  style={{
                    fontWeight: 'bold',
                    color: isEngineOn ? '#1e9b24' : '#b81414',
                    backgroundColor: isEngineOn ? '#95f39a' : '#ffb4b4',
                    border: 'none',
                  }}
                >
                  {isEngineOn ? 'ON' : 'OFF'}
                </Tag>
              </Item>
            </MobileSummaryGrid>

            {/* <Tabs
              className='custom-tabs-vessel-popup'
              type='card'
              style={{
                flex: 1,
              }}
              size='small'
              defaultActiveKey={activeTab}
              activeKey={activeTab}
              items={items}
              onChange={(e) => setActiveTab(e)}
            /> */}
            <ContentWrapper>
              <GridContent>
                <ItemContent
                  label='Latitude'
                  value={latitudeFormat(latitude, longitude)}
                />
                <ItemContent
                  label='Longitude'
                  value={longitudeFormat(latitude, longitude)}
                />
              </GridContent>

              <GridContent>
                <ItemContent
                  label='Altitude'
                  value={altitude ? (altitude as number).toFixed(2) : '-'}
                />
                <ItemContent
                  label='Speed'
                  value={toKnot(Number(speed) ?? 0).toFixed(2) + '  Knot'}
                />
              </GridContent>

              {rpmPort && (
                <GridContent>
                  <ItemContent
                    label='RPM Port'
                    value={
                      rpmPort.rpm || typeof rpmPort.rpm === 'number'
                        ? rpmPort.rpm.toFixed(2)
                        : '-'
                    }
                  />
                  <ItemContent
                    label='Last Updated'
                    value={
                      rpmPort.timestamp
                        ? convertTimestampToDate(rpmPort.timestamp)
                        : '-'
                    }
                  />
                </GridContent>
              )}

              {rpmStarboard && (
                <GridContent>
                  <ItemContent
                    label='RPM Starboard'
                    value={
                      rpmStarboard.rpm || typeof rpmStarboard.rpm === 'number'
                        ? rpmStarboard.rpm.toFixed(2)
                        : '-'
                    }
                  />
                  <ItemContent
                    label='Last Updated'
                    value={
                      rpmStarboard.timestamp
                        ? convertTimestampToDate(rpmStarboard.timestamp)
                        : '-'
                    }
                  />
                </GridContent>
              )}

              {rpmCenter && (
                <GridContent>
                  <ItemContent
                    label='RPM Center'
                    value={
                      rpmCenter.rpm || typeof rpmCenter.rpm === 'number'
                        ? rpmCenter.rpm.toFixed(2)
                        : '-'
                    }
                  />
                  <ItemContent
                    label='Last Updated'
                    value={
                      rpmCenter.timestamp
                        ? convertTimestampToDate(rpmCenter.timestamp)
                        : '-'
                    }
                  />
                </GridContent>
              )}
            </ContentWrapper>
          </PopupBody>

          {pathname.includes('/home') && (
            <ActionWrapper>
              <GridSetting>
                <Button
                  onClick={() => onClickAction('report')}
                  size='small'
                  type='primary'
                  color='#0957C2'
                >
                  View Report
                </Button>
                <Button
                  onClick={() => onClickAction('dashboard')}
                  size='small'
                  type='primary'
                  className='btn-accent'
                  color='black'
                >
                  View Dashboard
                </Button>
              </GridSetting>
            </ActionWrapper>
          )}
        </>
      )}
    </Container>
  );
};

interface IItemProps {
  label: string;
  value: string;
}

const ItemContent: React.FC<IItemProps> = ({ label, value }) => {
  return (
    <Item>
      <div>{label}</div>
      <p>{value}</p>
    </Item>
  );
};

const LastUpdated = styled.div`
  display: none;
`;

const AssetInfo = styled.div`
  font-size: 10px;
  opacity: 65%;
  margin-top: -5px;
`;

const PopupGlobalStyle = createGlobalStyle`
  .custom-vessel-popup .leaflet-popup-content {
    width: min(276px, calc(100vw - 64px)) !important;
    margin: 0 !important;
  }

  .custom-vessel-popup.leaflet-popup {
    margin-bottom: 18px;
  }

  .custom-vessel-popup .leaflet-popup-content-wrapper {
    padding: 0;
    overflow: hidden;
    border-radius: 4px;
  }

  .custom-vessel-popup .leaflet-popup-close-button {
    top: 6px;
    right: 8px;
    z-index: 2;
    color: #6b7280;
    font-size: 20px;
    line-height: 24px;
  }

  @media (min-width: 768px) {
    .custom-vessel-popup .leaflet-popup-content {
      width: 360px !important;
      margin: 0 !important;
    }

    .custom-vessel-popup.leaflet-popup {
      margin-bottom: 20px;
    }

    .custom-vessel-popup .leaflet-popup-content-wrapper {
      border-radius: 8px;
    }

    .custom-vessel-popup .leaflet-popup-close-button {
      top: 8px;
      right: 10px;
    }
  }
`;

const Container = styled.div`
  border-radius: 4px;
  width: auto;
  overflow: hidden;
  background: #fff;
  max-height: calc(100dvh - 176px);
  overflow-y: auto;

  img {
    width: 100%;
    height: 172px;
    object-fit: cover;
  }

  @media (min-width: 768px) {
    border-radius: 8px;
    max-height: none;
  }
`;

const PopupHeader = styled.div`
  display: block;
  padding: 8px 32px 6px 10px;
  margin-bottom: 0;
  border-bottom: none;

  @media (min-width: 768px) {
    padding: 10px 36px 8px 12px;
  }
`;

const HeaderTitleGroup = styled.div`
  min-width: 0;
`;

const StatusGroup = styled.div`
  display: none;
  gap: 5px;

`;

const PopupBody = styled.div`
  display: block;
  gap: 15px;

`;

const ImageFrame = styled.div`
  height: 92px;
  flex: 1;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0;
  }

  @media (min-width: 768px) {
    height: 118px;
  }
`;

const MobileSummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 4px 6px;
  padding: 6px 10px 3px;

  @media (min-width: 768px) {
    gap: 6px 8px;
    padding: 8px 12px 4px;
  }
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.25;

  @media (min-width: 768px) {
    font-size: 15px;
  }
`;

const ContentWrapper = styled.div`
  display: grid;
  flex: 1;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 4px 6px;
  padding: 6px 10px;
  border-bottom: 1px solid #e8ecf3;

  @media (min-width: 768px) {
    gap: 6px 8px;
    padding: 8px 12px;
  }
`;

const ActionWrapper = styled.div`
  // padding: 10px 20px 10px 20px;
  // background-color: #f4f6f9;
  padding: 6px 10px 8px;
  background: #f4f6f9;

  @media (min-width: 768px) {
    padding: 8px 12px 10px;
  }
`;

const FlexBetween = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
`;
const GridContent = styled.div`
  display: contents;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 5px;

`;

const Separator = styled.div`
  height: 1px;
  background-color: #e8ecf3;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
`;

const Item = styled.div`
  flex: 1;
  font-size: 12px;
  min-width: 0;
  margin-bottom: 0;

  div {
    color: #738197;
    font-size: 9px;
    line-height: 1.2;
    margin-bottom: 2px;
  }

  p {
    color: #000;
    margin: 0;
    font-size: 11px;
    line-height: 1.35;
    word-break: break-word;
  }

  @media (min-width: 768px) {
    div {
      font-size: 10px;
    }

    p {
      font-size: 12px;
    }
  }

  @media (max-width: 767px) {
    .ant-tag {
      margin-inline-end: 0;
      padding-inline: 5px;
      font-size: 10px;
      line-height: 18px;
    }
  }

`;

const StatusItem = styled(Item)<{ $width: number }>`
  flex: 0 0 ${({ $width }) => $width}px;
  width: ${({ $width }) => $width}px;
`;

const GridSetting = styled.div<{ custom?: boolean }>`
  display: grid;
  align-items: center;
  grid-template-columns: ${(props) => (props.custom ? '1fr' : '1fr 1fr')};
  gap: 10px;

  .ant-btn {
    height: 30px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    padding: 4px 10px;
  }

  @media (min-width: 768px) {
    .ant-btn {
      height: 34px;
      font-size: 12px;
    }
  }
`;

const ItemSetting = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export default MapVesselPopup;
